export default __webpack_public_path__ + "static/media/CS_31.c6dcb641.png";